import { STAFF_FILTER_ALL } from '../pages/messages/useMessagesInboxStaffFilter'

export const STAFF_FILTER_UNASSIGNED_VALUE = '-1'

/**
 * Inserts the Unassigned option directly after "Show all" in designer filter options.
 */
export const insertUnassignedOption = (options, unassignedLabel) => {
  const hasUnassigned = options.some(
    (opt) => String(opt.value) === STAFF_FILTER_UNASSIGNED_VALUE
  )
  if (hasUnassigned) {
    return options
  }
  const unassignedOption = {
    value: STAFF_FILTER_UNASSIGNED_VALUE,
    label: unassignedLabel,
  }
  const allIndex = options.findIndex(
    (opt) => String(opt.value) === STAFF_FILTER_ALL
  )
  if (allIndex === -1) {
    return [unassignedOption, ...options]
  }
  return [
    ...options.slice(0, allIndex + 1),
    unassignedOption,
    ...options.slice(allIndex + 1),
  ]
}

export const isUnassignedSelection = (selectedKey) =>
  String(selectedKey) === STAFF_FILTER_UNASSIGNED_VALUE
